<template>
  <header>
    <TheHeader v-if="showHeader" @toggleSidebar="showSidebar = !showSidebar" />
  </header>
  <div class="body-content">
    <sidebar :class="{ 'show-sidebar': showSidebar }">
      <TheSidebar></TheSidebar>
    </sidebar>
    <div
      :class="{
        'main-content': showHeader,
        'main-content-margin': showSidebar
      }"
    >
      <div class="container-fluid">
        <router-view></router-view>
      </div>
    </div>
  </div>

  <!-- Global Loading Modal Start -->
  <button
    style="display: none"
    type="button"
    id="globalLoadingModalBtn"
    data-bs-toggle="modal"
    data-bs-target="#globalLoadingModal"
  ></button>
  <div
    class="modal fade"
    id="globalLoadingModal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="globalLoadingModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body" style="text-align: center">
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem"
            role="status"
          >
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Global Loading Modal End -->

  <!-- Image Viewer Start -->
  <teleport to="body">
    <ImageViewer></ImageViewer>
  </teleport>
  <!-- Image Viewer Ends -->
</template>

<script>
import TheSidebar from '@/components/nav/Sidebar.vue';
import TheHeader from '@/components/nav/TheHeader.vue';
import ImageViewer from '@/components/UI/ImageViewer.vue';

export default {
  name: 'DefaultLayout',
  components: {
    TheHeader,
    TheSidebar,
    ImageViewer
  },
  data() {
    return {
      showHeader: true,
      showSidebar: true
    };
  },

  mounted() {
    this.pathRoute = this.$route.name;

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.showSidebar = false;
    }

    if (this.$route.name === 'trip-create-external') {
      this.showSidebar = false;
      this.showHeader = false;
    }
  },

  methods: {}
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
}

header {
  /* height: 75px; */
  background: #fff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 500;
}

sidebar {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 400;
  top: 0;
  left: 60;
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
  overflow-x: hidden;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
}

.container-fluid {
  padding: 0 24px;
}

.show-sidebar {
  width: 250px !important;
}

.main-content {
  transition: margin-left 0.5s;
  padding-top: 104px;
}
.main-content-margin {
  margin-left: 250px;
}

@media only screen and (max-width: 600px) {
  .main-content-margin {
    margin-left: 0px;
  }
}
</style>
